import React, { useEffect, useState } from 'react';
import { Wordmark } from './Wordmark';
import { MobileMenu } from './MobileMenu';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Check if scrolled past hero (approx 100vh)
      setIsScrolled(window.scrollY > window.innerHeight - 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${isScrolled ? 'bg-ink py-4 shadow-md' : 'bg-transparent py-6 md:py-8'}`} data-id="element-217">
        <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-218">
          <div className={`transition-opacity duration-500 ${isScrolled ? 'opacity-100' : 'opacity-100 md:opacity-100'}`} data-id="element-219">
            <Wordmark variant="horizontal" color="white" data-id="element-220" />
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-221">
            {['HOME', 'STUDIO', 'PRACTICE', 'RESONANCE', 'BEGIN'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="font-mono text-[12px] tracking-[0.2em] uppercase text-white hover:text-brass transition-colors" data-id="element-222">
                  {item}
                </a>)}
          </nav>

          {/* Mobile Hamburger */}
          <button className="md:hidden flex flex-col gap-1.5 p-2 z-50" onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-223">
            <span className="w-6 h-[1px] bg-white block" data-id="element-224"></span>
            <span className="w-6 h-[1px] bg-white block" data-id="element-225"></span>
          </button>
        </div>
      </header>

      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} data-id="element-226" />
    </>;
}